// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608041827/js/" + chunkId + "." + {"44":"0d50dae6","225":"7da98032","481":"4a481db0","486":"97c79c70","770":"afbafbef"}[chunkId] + ".0.8574053339830647.chunk.js";
};